import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {FileModel} from '../file.model'
import type {IconDefinition} from '@fortawesome/fontawesome-common-types'

@Component({
  selector: 'cft-file-preview',
  templateUrl: './file-preview.component.html',
  styles: `
    @reference '../../../../styles/theme.css';

    .thumbnail {
      @apply h-40 w-full rounded-t-1 object-cover;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FilePreviewComponent {
  file = input.required<FileModel>()
  icon = input.required<IconDefinition>()
}
